
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export interface ApiKey {
  id: string;
  name: string;
  value: string;
  isVisible: boolean;
}

interface ApiSettingsTabProps {
  apiKeys: ApiKey[];
  toggleApiKeyVisibility: (index: number) => void;
}

export const ApiSettingsTab = ({ apiKeys, toggleApiKeyVisibility }: ApiSettingsTabProps) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold mb-4">API Settings</h2>
      <div className="space-y-6">
        {apiKeys.map((key, index) => (
          <div key={index} className="p-4 border rounded-md">
            <div className="flex items-center justify-between mb-2">
              <p className="font-medium">{key.name}</p>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => toggleApiKeyVisibility(index)}
              >
                {key.isVisible ? 'Hide' : 'Show'}
              </Button>
            </div>
            <div className="flex items-center gap-2">
              <Input
                type={key.isVisible ? "text" : "password"}
                value={key.isVisible ? import.meta.env.VITE_ALPHA_VANTAGE_API_KEY || key.value : "••••••••••••••••"}
                readOnly
                className="font-mono"
              />
              <Button variant="outline" size="sm">
                Copy
              </Button>
            </div>
            <p className="text-sm text-gray-500 mt-2">
              Used for market data retrieval from Alpha Vantage
            </p>
          </div>
        ))}
        
        <div className="pt-2">
          <Button variant="outline">
            Regenerate API Keys
          </Button>
        </div>
      </div>
    </div>
  );
};
